import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { CompanySearchPanel } from '../-components/CompanySearchPanel';
import { useCompanySearchPage } from '../-hooks/useCompanySearchPage';

export const Route = createFileRoute('/onboarding/company-search/(pages)/')({
  component: CompanySearchPage,
});

function CompanySearchPage() {
  const {
    query,
    onQueryChange,
    companies,
    companyProcessLabels,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    onFetchNextPage,
    requestedCompanyIds,
    pendingCompanyIds,
    onAskToJoin,
  } = useCompanySearchPage();

  return (
    <PageContainer>
      <CompanySearchPanel
        query={query}
        onQueryChange={onQueryChange}
        companies={companies}
        companyProcessLabels={companyProcessLabels}
        isLoading={isLoading}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        onFetchNextPage={onFetchNextPage}
        requestedCompanyIds={requestedCompanyIds}
        pendingCompanyIds={pendingCompanyIds}
        onAskToJoin={onAskToJoin}
      />
    </PageContainer>
  );
}
